import { useQuery } from "@tanstack/react-query";
import CurrencyService from "../services";
import { SortField } from "../../../utils/schema/SortType";
import qs from "qs";

interface useCurrencyParams {
  sortFields?: SortField[];
  page?: number;
  rowsPerPage?: number;
  searchText?: string;
}
export const useCurrency = ({
  sortFields,
  page,
  rowsPerPage,
  searchText,
}: useCurrencyParams = {}) => {

  const sortParam = sortFields
          ? sortFields.map(({ field, order }) => `${field}:${order}`)
          : undefined;

          const query = qs.stringify(
            {
              sort: sortParam,
              pagination: {
                page,
                pageSize: rowsPerPage,
              },
              populate: '*',
              filters: searchText ? { name: { $contains: searchText }  } : undefined,
          },
            { encodeValuesOnly: true }
            
          );

  return useQuery({
    queryKey: ["currencies", query],
    queryFn: () => CurrencyService.getAll({query}),
  });
};
